'use client'

import { useEffect } from 'react'

import { PublicStyles } from '@/components/server/styles/public-styles'
import { useTranslation } from '@/hooks/client/use-translation'
import { sentryCall } from '@/lib/log/sentry-client'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function RouteError({ error, reset }: Props) {
  const { t } = useTranslation()

  useEffect(() => {
    sentryCall((Sentry) => Sentry.captureException(error))
  }, [error])

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 py-16">
      <PublicStyles />
      <h1 className="text-navy text-4xl font-bold">{t('error.title', 'Something went wrong')}</h1>
      <p className="text-navy-60 text-center text-lg">
        {t('error.message', 'An unexpected error occurred. Our team has been notified.')}
      </p>
      <button
        type="button"
        onClick={reset}
        data-tracking="ignore"
        className="bg-lapis hover:bg-navy cursor-pointer rounded-full px-6 py-3 text-white transition-colors"
      >
        {t('error.retry', 'Try again')}
      </button>
    </main>
  )
}
